module.exports = __webpack_public_path__ + "img/t1-bg.22645ddd.png";